export default __webpack_public_path__ + "static/media/tour-img-2.9967ef8f.svg";